export default __webpack_public_path__ + "static/media/icon-confirma.785e0d26.svg";